import styled from 'styled-components';
import {dFlex} from '../../../../globalVariables/GlobalVariables';
import {tokens} from '@tickchak/react-share/app';
import {Template} from '../../../../component/templates/Template.css';

const BLOCK = '#F3F3F3';

export const card = styled.div<{ $previous?: boolean }>`
    ${dFlex};
    flex-direction: column;
    align-items: center;
    gap: var(--space-lg);
    width: 100%;
    height: ${p => (p.$previous ? '148px' : '263px')};
    padding: var(--space-xl) var(--space-md) var(--space-md);
    box-sizing: border-box;
    border: 1px solid ${tokens.color.border.subtle};
    border-radius: var(--radius-md);
    background: ${tokens.color.bg.base};
    overflow: hidden;
    ${Template('320px')}
`;

export const avatar = styled.div<{ $previous?: boolean }>`
    width: ${p => (p.$previous ? '32px' : '66px')};
    height: ${p => (p.$previous ? '32px' : '66px')};
    border-radius: 50%;
    background: ${BLOCK};
    flex-shrink: 0;
`;

export const line = styled.div<{ $short?: boolean }>`
    width: ${p => (p.$short ? '40%' : '70%')};
    height: 14px;
    border-radius: 25px;
    background: ${BLOCK};
`;

export const footer = styled.div`
    margin-top: auto;
    width: 100%;
    height: 32px;
    border-radius: var(--radius-full);
    background: ${BLOCK};
`;
